import ListPresentationMain from './ListPresentationMain';

// This is ListPresentation wrapper that wraps main component in a context

export default function ListPresentationWrapper() {
  return <ListPresentationMain />;
}
